import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

export interface IGenerateBlogTags extends IAction<string[], GenerateBlogTagsArgs> {}

@InputType()
export class GenerateBlogTagsArgs extends ActionArgs {
  @Field(() => ID)
  blogId: string
}
